import { useT } from '../i18n';
import './PrivacyPolicy.css';

interface PrivacyPolicyProps {
  onBack: () => void;
}

/**
 * Placeholder policy. It states purpose, retention and contact so the consent
 * checkbox links to something real, but the 24-month figure and the contact
 * details must be confirmed with counsel before launch — see README.
 */
export function PrivacyPolicy({ onBack }: PrivacyPolicyProps) {
  const t = useT();

  return (
    <article className="policy">
      <header className="policy__header">
        <h1>{t.privacy.title}</h1>
        <p className="policy__meta">
          <span className="eyebrow">{t.privacy.lastUpdatedLabel}</span>
          <span>{t.privacy.lastUpdated}</span>
        </p>
      </header>

      <div className="policy__body">
        {t.privacy.sections.map((section) => (
          <section key={section.heading} className="policy__section">
            <h2>{section.heading}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>

      <button type="button" className="btn" onClick={onBack}>
        {t.privacy.back}
      </button>
    </article>
  );
}
